import EnumSet from 'Services/enumSet'

interface ISignupLead extends EnumSet {
  none: number
  coteibem: number
  sindiconet: number
  meucondominio: number
  vendavalida: number
}

const signupLead = new EnumSet({
  none: { value: 0, description: 'Nenhum' },
  coteibem: { value: 1, description: 'CoteiBem' },
  sindiconet: { value: 2, description: 'SindicoNet' },
  meucondominio: { value: 3, description: 'MeuCondominio' },
  vendavalida: { value: 4, description: 'Venda Válida' }

}) as ISignupLead

export default signupLead